import dayjs from 'dayjs';
import { Submission } from '@repo/api/open-calls/graphql';
import type {
  CandidateInfoAboutConfig,
  CandidateInfoAboutRow,
} from '@repo/ui/components/custom/candidate/info/about/component';

export function getLegacyCandidateAboutConfig(
  nationalityLabel = 'Nationality',
): CandidateInfoAboutConfig {
  return {
    getRows: (candidate) =>
      getLegacyCandidateAboutRows(candidate, nationalityLabel),
    title: 'About',
  };
}

function getLegacyCandidateAboutRows(
  candidate: Submission,
  nationalityLabel: string,
): CandidateInfoAboutRow[] {
  const nationality = candidate.profile.nationality || '';
  const nationalityList = nationality
    .split(',')
    .map((n) => n.trim())
    .join(' - ');
  const location = [
    candidate.profile.address?.city,
    candidate.profile.address?.country,
  ]
    .filter(Boolean)
    .join(', ');

  // TODO (open-call-types): Remove this fallback once candidate data is always typed for this view.
  const agencyName = candidate.data.personalDetails?.agencyName ?? '';

  return [
    {
      label: 'Age',
      requiresCandidateInfoPermission: true,
      value: calculateAge(candidate.profile.dob),
    },
    {
      label: 'City',
      value: location,
    },
    {
      label: nationalityLabel,
      value: nationalityList,
    },
    {
      label: 'Represented By',
      value: agencyName,
    },
  ];
}

function calculateAge(dob: string | number | null | undefined): string {
  // It could arrive as ISO string or timestamp as string
  // Examples: "2020-01-01" or "1577836800000"
  // TODO: standardize the format of the dob on the backend

  if (!dob) return '-';
  if (!isNaN(Number(dob))) {
    return dayjs()
      .diff(dayjs(Number(dob)), 'year')
      .toString();
  }
  return dayjs().diff(dayjs(dob), 'year').toString();
}
